// extracted by mini-css-extract-plugin
module.exports = {"closed":"_6zIdxfKWSsUoIal5wv-GIg==","opened":"JVp22Oi8VB898aKnDiJsLA=="};